// extracted by mini-css-extract-plugin
export default {"imageContainer":"ItemImage_imageContainer__gB-do"};